// @flow
import type {Node} from 'react'
import React, {PureComponent} from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import classNames from 'classnames'

import RoleAutocomplete from 'components/ui/RoleAutocomplete'
import InputWithAiSuggest from 'components/ai/AiSuggest/InputWithAiSuggest'
import type {AiSuggestProps} from 'components/ai/AiSuggest/AiSuggestion'

import styles from './index.scss'

export type Organization = $ReadOnly<{
  databaseId: string,
  ...
}>

export type Circle = $ReadOnly<{
  databaseId: string,
  ...
}>

type Props = $ReadOnly<{
  circle: ?Circle,
  className: string,
  containerClassName?: string,
  disabled: boolean,
  id: string,
  name?: string,
  onChange: SyntheticInputEvent<> => void,
  onKeyDown: ?(event: SyntheticKeyboardEvent<HTMLTextAreaElement>) => void,
  onFocus?: () => void,
  organization: Organization,
  rows: ?(number | string),
  shouldFocus: boolean,
  strikethrough: boolean,
  textarea: boolean,
  value: string,
  placeholder: string,
  aiSuggestProps?: AiSuggestProps | void
}>

class AutocompleteInput extends PureComponent<Props> {
  static defaultProps: {
  circle: null,
  className: string,
  disabled: boolean,
  onFocus: null,
  onKeyDown: null,
  placeholder: string,
  rows: number,
  shouldFocus: boolean,
  strikethrough: boolean,
} = {
      circle: null,
      className: '',
      disabled: false,
      rows: 2,
      strikethrough: false,
      shouldFocus: false,
      onKeyDown: null,
      onFocus: null,
      placeholder: I18n.t('proposals.rewrite.unspecified'),
    }

  componentDidMount() {
    if (this.props.shouldFocus && this.inputRef)
      this.inputRef.focus()
  }

  get inputClassName(): string {
    return classNames(
      this.props.className,
      'form-control',
      'refinery-input',
      'refinery-value-pill',
      {'refinery-input--strikethrough': this.props.strikethrough},
    )
  }

  get inputProps(): {
  className: string,
  disabled: boolean,
  id: string,
  name: void | string,
  onChange: (SyntheticInputEvent<>) => void,
  onFocus?: () => void,
  onKeyDown: ?((event: SyntheticKeyboardEvent<HTMLTextAreaElement>) => void),
  tabIndex: number,
  value: string,
  } {
    return {
      className: this.inputClassName,
      disabled: this.props.disabled,
      id: this.props.id,
      name: this.props.name,
      onChange: this.props.onChange,
      tabIndex: 0,
      value: this.props.value,
      onKeyDown: this.props.onKeyDown,
      onFocus: this.props.onFocus,
    }
  }

  focus: (() => void) = () => {
    if (this.inputRef)
      this.inputRef.focus()
  }

  saveRef: ((ref: ?HTMLElement) => void) = (ref: ?HTMLElement) => {
    this.inputRef = ref
  }

  inputRef: ?HTMLElement

  // eslint-disable-next-line react/no-arrow-function-lifecycle
  render: (() => Node) = () => (
    <RoleAutocomplete
      circleDatabaseId={this.props.circle && this.props.circle.databaseId}
      onChange={this.props.onChange}
      orgDatabaseId={this.props.organization.databaseId}
    >
      {this.props.textarea ? (
        <TextareaAutosize
          {...this.inputProps}
          autoFocus={this.props.shouldFocus}
          minRows={this.props.rows}
          placeholder={this.props.placeholder}
        />
      ) : (
        // $FlowFixMe[prop-missing]
        <InputWithAiSuggest
          {...this.inputProps}
          inputRef={this.saveRef}
          aiSuggestProps={this.props.aiSuggestProps}
          containerClassName={classNames(styles.inputContainer, this.props.containerClassName)}
        />
      )}
    </RoleAutocomplete>
  )
}

export default AutocompleteInput
